import Vue from 'vue'
import Router from 'vue-router'

import CleanerLayout from '../views/cleaner/CleanerLayout.vue'
import CleanerHome from '../views/cleaner/Home.vue'
import CleanerOrders from '../views/cleaner/Orders.vue'
import CleanerMine from '../views/cleaner/Mine.vue'
import CleanerSchedule from '../views/cleaner/Schedule.vue'
import CleanerOrderDetail from '../views/cleaner/OrderDetail.vue'
import Login from '../views/Login.vue'
import BizLogin from '../views/BizLogin.vue'
import Wx from '../views/Wx.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/cleanerPage/home'
    },
    {
      path: '/Wx',
      name: 'Wx',
      component: Wx
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/bizlogin',
      name: 'BizLogin',
      component: BizLogin
    },
    {
      path: '/cleanerPage',
      component: CleanerLayout,
      children: [
        {
          path: 'home',
          name: 'CleanerHome',
          component: CleanerHome
        },
        {
          path: 'orders',
          name: 'CleanerOrders',
          component: CleanerOrders
        },
        {
          path: 'schedule',
          name: 'CleanerSchedule',
          component: CleanerSchedule
        },
        {
          path: 'mine',
          name: 'CleanerMine',
          component: CleanerMine
        }
      ]
    },
    {
      path: '/cleanerOrder/order/:id',
      name: 'CleanerOrderDetail',
      component: CleanerOrderDetail
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.path === '/login') return next()
  if (to.path === '/bizlogin') return next()
  if (to.path === '/Wx') return next()
  if (to.path === '/wx') return next()
  const token = localStorage.getItem('lxz-token') || ''
  if (token) return next()
  return next({ path: '/login', query: { redirect: to.fullPath } })
})

export default router
